/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Manages all attribute mappings, there are a couple level of mappings.
 *  Raw Event -> Event Mapping (uniqueid) -> Adjusted -> Global Mapping (legacy) -> Normalized -> Profile Mapping (transports) -> Transport Payload
 *
 *   - Event Mapping: maps uniqueid specific attributes for hot-fixes / fitting problems, etc. This should be used as last resort
 *   - Global Mapping: maps all events for handling legacy / short form / alias names
 *   - Profile Mapping: maps events specific for a profile. Each transport utilizes their own JSON names
 *
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { JSONManager, globalEngine, ModuleManager } from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreateMapping()
{
    var mappings =
    {
        "eventMap": function(obj, uniqueid)
        {
            if (!(uniqueid in this._eventTable))
            {
                return obj;
            }
            return this._map(this._eventTable[uniqueid], obj, true);
        },

        "globalMap": function(obj)
        {
            return this._map(this._globalTable, obj, true);
        },

        "profileMap": function(obj, profile)
        {
            if (!(profile in this._profileTable))
            {
                return obj;
            }
            return this._map(this._profileTable[profile], obj, true);
        },

        // this is used to pass to the C++ layer for transport plugins
        "getProfileTableStr": function(profile)
        {
            if (!(profile in this._profileTableStr))
            {
                return '{}';
            }
            else
            {
                return this._profileTableStr[profile];
            }
        },

        // this is a special mapping required for CSP v1
        "getFlippedProfileTable": function(profile)
        {
            if (!(profile in this._profileTable))
            {
                logError("Requesting flipped table for invalid profile " + profile);
                return {};
            }

            // if already created, just return it
            if (profile in this._flippedProfileTable)
            {
                return this._flippedProfileTable[profile];
            }

            // table does not exist, create one
            this._flippedProfileTable[profile] = {};
            for (var key in this._profileTable[profile])
            {
                var newKey = this._profileTable[profile][key];
                this._flippedProfileTable[profile][newKey] = key;
            }
            return this._flippedProfileTable[profile];
        },

        // general helper function
        "_map": function(mappingTable, toMap, inPlace)
        {
            if (!mappingTable || !toMap || (typeof toMap !== "object"))
            {
                logError("Invalid mappingTable or toMap");
                return toMap;
            }

            logDebug("Executing mappings::_map " + (inPlace ? "in place" : "in new buffer"));
            var newMap = {};

            for (var attribute in toMap)
            {
                var lowerAttribute = attribute.toLowerCase();
                if (lowerAttribute in mappingTable)
                {
                    var newAttribute = mappingTable[lowerAttribute];
                    if (inPlace)
                    {
                        toMap[newAttribute] = toMap[attribute];
                        if (newAttribute != attribute)
                        {
                            delete toMap[attribute];
                        }
                    }
                    else
                    {
                        newMap[newAttribute] = toMap[attribute];
                    }
                }
            }
            return inPlace ? toMap : newMap;
        },

        "toLowerCase": function(table, lowerKey, lowerValue)
        {
            for (var item in table)
            {
                var newItem = lowerKey ? item.toLowerCase() : item;
                table[newItem] = lowerValue ? table[item].toLowerCase() : table[item];
                if (newItem != item)
                {
                    delete table[item];
                }
            }
            return table;
        },

        // initialization function
        "_initialize": function()
        {
            try
            {
                var file = JSONManager.create("dictionary");
                this._eventTable = file["event"];
                this._profileTable = file["profile"];
                this._globalTable = file["global"];

                // lower case event table, global table, and only keys of profile table
                this._eventTable = this.toLowerCase(this._eventTable, true, true);
                this._globalTable = this.toLowerCase(this._globalTable, true, true);
                for (var profile in this._profileTable)
                {
                    this._profileTable[profile] = this.toLowerCase(this._profileTable[profile], true, false);
                }

                // cache / pre-stringify all the profiles
                for (var profile in this._profileTable)
                {
                    this._profileTableStr[profile] = JSON.stringify(this._profileTable[profile]);
                }
            }
            catch (e)
            {
                logError("ERROR: Could not load dictionary.json into tables " + e.message);
            }
        },

        _eventTable: {},
        _profileTable: {},
        _globalTable: {},
        _flippedProfileTable: {},

        // instead of JSON.stringify every single time we send the profiles to C++, buffer the strings
        _profileTableStr: {}
    }

    mappings._initialize();
    return mappings;
}

ModuleManager.registerFactory("mappings", CreateMapping);

//export  {CreateMapping};
//globalEngine.FactoryMap["mappings"] =  CreateMapping;
